import '.ax{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.gr{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.an{justify-content:center;}.ssr-plugin'
import '.aw{align-items:flex-start;}.ssr-plugin'
import '.bo{padding:2rem;}.ssr-plugin'
import '.dz{background:var(--palette-white);}.ssr-plugin'
import '.a8{overflow:hidden;}.ssr-plugin'
import '.bs{position:absolute;}.ssr-plugin'
import '.j5{top:50%;}.ssr-plugin'
import '.j6{right:1rem;}.ssr-plugin'
import '.j7{transform:translateY(-50%);}.ssr-plugin'
import '.j8{width:120px;}.ssr-plugin'
import '.j9{height:120px;}.ssr-plugin'
import '.ja{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ig{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jb{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ax n gr d e an aw bo dz a8"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bs j5 j6 j7 j8 j9 ja d r an"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ax ig d e aw s jb"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
